module.exports = __webpack_public_path__ + "static/media/opportunity-section-image-2.c44d2ce5.png";